import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    APIClient,
    api
} from '../../helpers/api_helper';
import Log from '../../Services/Log';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';


export const getCatalogue = createAsyncThunk('catalogs/getAll', async ({limit,page}, thunkAPI) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.CATALOGS.GET_ALL}?limit=${limit}&status=all&page=${page}`);

        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});
export const addCatalogue = createAsyncThunk('catalogs/add', async (dataToSend, thunkAPI) => {
    try {
        const response = await api.create(API_ENDPOINTS.CATALOGS.ADD, dataToSend);
        return response.data;
    } catch (error) {
        if (error.response) {
            return thunkAPI.rejectWithValue(error.response.data);
        } else {
            return thunkAPI.rejectWithValue({
                error: error.message
            });
        }
    }
});
export const updateCatalogue = createAsyncThunk('catalogs/update', async (catalogueData, thunkAPI) => {
    const {
        id,
        ...data
    } = catalogueData;
    try {
        const response = await api.put(API_ENDPOINTS.CATALOGS.UPDATE, catalogueData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});


export const deleteCatalogue = createAsyncThunk('catalogs/delete', async (id, thunkAPI) => {
        try {
            const response = await api.delete(API_ENDPOINTS.CATALOGS.DELETE(id)); 
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);